import { getMinorUnit } from 'constants/Currencies';
import { between, packValidateResults, required } from 'helpers/validators';

export const validate = (data: any, maxRefundAmount: number | string, currency: string) => {
  const minAmount = Math.pow(10, -getMinorUnit(currency));
  return packValidateResults([
    required(data, ['amount', 'refund_reason']),
    between(data, ['amount'], { min: minAmount, max: maxRefundAmount }),
  ]);
};
